<template>
  <v-system-bar
    v-if="showBanner"
    height="40"
    class="ucollaborate-version-banner px-4"
    role="status"
    aria-live="polite"
  >
    <v-icon size="small" class="sparkle-icon mr-2" aria-hidden="true">
      fa-solid fa-sparkles
    </v-icon>
    <span class="text-body-2 font-weight-medium mr-6">{{ bannerText }}</span>
    <button
      type="button"
      class="ucollab-toggle-link text-decoration-underline text-body-2 font-weight-medium"
      @click="toggleView"
    >
      {{ linkText }}
    </button>
  </v-system-bar>
</template>

<script>
export default {
  name: "UcollaborateVersionBanner",
  props: {
    available: { type: Boolean, default: false }
  },
  computed: {
    showBanner() {
      return this.available;
    },
    isLegacyView() {
      return this.$store.getters.isLegacyUcollaborateView;
    },
    bannerText() {
      return this.isLegacyView
        ? "You are using the previous version of Ucollaborate"
        : "You are using the new Ucollaborate";
    },
    linkText() {
      return this.isLegacyView ? "Switch to the new Ucollaborate" : "Switch to the previous version";
    }
  },
  methods: {
    toggleView() {
      this.$store.commit(
        "SET_UCOLLABORATE_VIEW_PREFERENCE",
        this.isLegacyView ? "new" : "legacy"
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@use "../../styles/base/variables" as *;

.ucollaborate-version-banner {
  background-color: $uwill-yellow !important;
  color: $uwill-black;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.ucollab-toggle-link {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  color: inherit;
  cursor: pointer;
}
.sparkle-icon {
  opacity: 1;
}
</style>
